<div class="card-body">
   <div class="d-flex justify-content-end mb-4">
      <div class="position-relative w-100 w-md-300px">
         <i class="fa fa-magnifying-glass position-absolute top-50 translate-middle-y ms-3 fs-7 text-muted"></i>
         <input type="text" class="form-control form-control-sm ps-10"
                [ngModel]="searchTerm"
                (ngModelChange)="onSearch($event)"
                [placeholder]="'CAMPAIGN.SEARCH_PLACEHOLDER' | translate" />
         <i *ngIf="searchTerm" class="fa fa-xmark position-absolute top-50 end-0 translate-middle-y me-3 fs-7 text-muted cursor-pointer"
            (click)="clearSearch()"></i>
      </div>
   </div>
   <div class="table-responsive">
      <table style="padding: 0px !important; margin: 0px !important; cursor: pointer;" class="table table-sm table-bordered table-hover table-row-gray-600 align-middle gs-10 ge-10">
         <thead class="table-sm">
            <tr class="fw-bolder text-muted bg-primary" style="color: #fff !important;">
               <th class="text-start" style="cursor: pointer; white-space: nowrap;" (click)="onSort('id')">
                  <span>{{ 'CAMPAIGN.ID' | translate }}</span>
                  <i [ngClass]="getSortIcon('id')"></i>
               </th>
               <th class="text-start">{{ 'CAMPAIGN.NAME' | translate }}</th>
               <th class="text-center">{{ 'WORKSPACES.TITLE' | translate }}</th>
               <th class="text-center">{{ 'CAMPAIGN.INCOMING_NUMBER' | translate }}</th>
               <th class="text-center">{{ 'CAMPAIGN.OUTGOING_NUMBER' | translate }}</th>
               <th class="text-center">{{ 'CAMPAIGN.TYPE' | translate }}</th>
               <th class="text-end">{{ 'CAMPAIGN.ACTIONS' | translate }}</th>
               <th class="text-center">{{ 'CAMPAIGN.STATUS' | translate }}</th>
            </tr>
         </thead>
         <tbody>
            <tr *ngFor="let campaign of sortedCampaigns; trackBy: trackByCampaign">
               <td>
                  <a href="#" class="text-gray-900 fw-bolder fs-7" (click)="viewCampaign(campaign, $event); $event.preventDefault()">{{ campaign.id }}</a>
               </td>
               <td class="text-start">
                  <a href="#" class="text-gray-900 fw-bolder d-block mb-1 fs-7" (click)="viewCampaign(campaign, $event); $event.preventDefault()">
                  {{ campaign.name }}
                  <span *ngIf="campaign.sharing === 1">
                  <i class="fa-sharp fa-solid fa-share-nodes text-primary ms-2 fs-5" [ngbTooltip]="'TOOLTIP.CAMPAIGN_SHARED_WITH_OTHERS' | translate"></i>
                  </span>
                  </a>
               </td>
               <td class="text-center">
                  <a href="#" class="text-gray-900 fw-bolder d-block mb-1 fs-7" (click)="viewWorkspaceCampaigns(campaign.name_workspace); $event.preventDefault()">
                  {{ campaign.name_workspace }}
                  </a>
               </td>
               <td class="text-center"> 
                  <a href="#" (click)="viewCampaign(campaign, $event); $event.preventDefault()" class="text-gray-900 fw-bolder d-block mb-1 fs-7">{{ campaign.phonenumber_in ? campaign.phonenumber_in : '-' }}</a>
               </td>
               <td class="text-center">
                  <a href="#" (click)="viewCampaign(campaign, $event); $event.preventDefault()" class="text-gray-900 fw-bolder d-block mb-1 fs-7">{{ campaign.phonenumber_out ? campaign.phonenumber_out : '-' }}</a>
               </td>
               <td class="text-center">
                  <i [class.fa-solid]="true" [class.fa-arrow-down]="campaign.type === 0" [class.fa-arrow-up]="campaign.type === 1" [class.fa-arrow-up-arrow-down]="campaign.type === 2" [class.text-success]="campaign.type === 0" [class.text-primary]="campaign.type === 1" [class.text-info]="campaign.type === 2" class="fs-5" [ngbTooltip]="
                  campaign.type === 0
                  ? ('TOOLTIP.INCOMING_CAMPAIGN' | translate)
                  : campaign.type === 1
                  ? ('TOOLTIP.OUTGOING_CAMPAIGN' | translate)
                  : ('TOOLTIP.MIXED_CAMPAIGN' | translate)
                  "></i>
               </td>
               <td class="text-end">
                  <a *ngIf="campaign.engine === 1" href="#" class="btn btn-icon btn-active-light-primary w-30px h-30px" ngbTooltip="{{ 'TOOLTIP.EDIT_PROMPT' | translate }}" (click)="openCreateAppModal(campaign, $event)">
                  <i class="fa-solid fa-sliders fs-5"></i>
                  </a>
                  <a href="#" ngbTooltip="{{ 'CAMPAIGN.EDIT_CAMPAIGN' | translate }}" class="btn btn-icon btn-active-light-primary w-30px h-30px" (click)="editCampaign(campaign, $event)">
                  <i class="fa-solid fa-pen-to-square fs-5"></i>
                  </a>
                  <a *ngIf="campaign.type === 1 || campaign.type === 2" href="#" ngbTooltip="{{ 'WEEKLY_SCHEDULE.PROMPT_TITLE' | translate }}" class="btn btn-icon btn-active-light-primary w-30px h-30px" (click)="openScheduleModal(campaign.public); $event.preventDefault()">
                   <i class="fa-regular fa-calendar-lines-pen fs-5"></i>
                   </a>
                   <a 
                     *ngIf="campaign.type === 1 || campaign.type === 2"
                      href="#"
                      ngbTooltip="{{ 'WEEKLY_SCHEDULE_AND_STEPS.PROMPT_TITLE' | translate }}"
                      class="btn btn-icon btn-active-light-primary w-30px h-30px"
                      (click)="openScheduleStepsModal(campaign.public); $event.preventDefault()"
                      >
                   <i class="fa-solid fa-clock-rotate-left fs-5"></i>
                   </a>
                   <!-- Campaign Report Icon -*ngIf="authService.hasRole(['superadmin', 'admin'])" -->
<a  href="#" 
class="btn btn-icon btn-active-light-primary w-30px h-30px" 
ngbTooltip="{{ 'CAMPAIGN.VIEW_REPORT' | translate }}" 
(click)="goToCampaignReport(campaign); $event.preventDefault()">
<i class="fa-solid fa-chart-line fs-5"></i>
</a>

                  <a href="#" class="btn btn-icon btn-active-light-primary w-30px h-30px" (click)="toggleFavourite(campaign); $event.preventDefault()" [ngbTooltip]="
                  campaign.isFavourite
                  ? ('TOOLTIP.REMOVE_FROM_FAVOURITES' | translate)
                  : ('TOOLTIP.ADD_TO_FAVOURITES' | translate)
                  ">
                  <i [class]="campaign.isFavourite ? 'fa-solid fa-star' : 'fa-regular fa-star'" class="fs-5 text-warning"></i>
                  </a>
                  <!-- <a href="#" ngbTooltip="{{ 'CAMPAIGN.GOTO_CAMPAIGN' | translate }}" class="btn btn-icon btn-active-light-primary w-30px h-30px me-3 text-end" (click)="viewCampaign(campaign, $event)"><i class="fa-solid fa-arrow-right fs-5"></i></a> -->
               </td>
               <td class="text-center">
                  <div class="form-check form-switch form-check-sm form-check-custom form-check-solid text-center text-end">
                     <input class="form-check-input w-25px h-15px text-center" type="checkbox" [checked]="campaign.is_activated" (change)="toggleStatus(campaign)" 
                     [class.bg-warning]="campaign.is_activated && (!campaign.online)" 
                     [class.bg-success]="campaign.is_activated && campaign.online" 
                     [class.bg-danger]="(!campaign.is_activated) && (!campaign.online)" />
                  </div>
               </td>
            </tr>
            <tr *ngIf="searchTerm && sortedCampaigns.length === 0">
               <td colspan="8" class="text-center text-muted py-5">
                  {{ 'CAMPAIGN.SEARCH_NO_RESULTS' | translate }}
               </td>
            </tr>
         </tbody>
      </table>
   </div>
</div>